import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { handleAIPromptFetch, handleCancelAiPrompt } from './hooks/aiAPI';
import { ToastNotification, NOTIFICATION_TYPES } from '../ToastNotification';

const AiActionButton = ({ isLoading, showButton, isServiceError }) => {
    const [showError, setShowError] = useState(isServiceError);

    useEffect(() => {
        setShowError(isServiceError);
    }, [isServiceError]);

    const handleRegen = async () => {
        const prompt = sessionStorage.getItem('ai-message-prompts');
        try {
            await handleAIPromptFetch(prompt);
        } catch (err) {
            setShowError(true);
        }
    };

    const handleCancel = async () => {
        await handleCancelAiPrompt();
        // remove the cancel button from the UI after cancel action is successful
        window.dispatchEvent(new CustomEvent('setAiActionButton', { detail: { showButton: false } }));
    };

    const closeError = () => {
        setShowError(false);
        handleCancel();
    };

    return (
        <>
            { showButton && (
                <>
                    { showError
                        && <div className="margin-t-16px">
                            <ToastNotification
                                isVisible={true}
                                notificationType={NOTIFICATION_TYPES.ERROR}
                                msg="AI Service is not responding, please refresh page and try again"
                                action={closeError}
                            />
                        </div>
                    }
                    {!showError
                        && <>
                            { isLoading
                                ? <button
                                    className="ai-action-button btn ai-btn-cancel"
                                    id="ai-cancel-btn"
                                    type="button"
                                    aria-label="Cancel AI Prompt"
                                    onClick={handleCancel}>
                                    <i className="fas fa-stop" alt="Cancel icon" aria-hidden="true"></i>
                                    <span className="btn__tooltip btn__tooltip--small btn__tooltip--down ai-message-tooltip bg-white font-gray-40 border-solid border-1px border-color-gray-80">
                                        Stop Generating Prompt
                                    </span>
                                </button>
                                : <button
                                    className="ai-action-button btn ai-btn-regen"
                                    id="ai-regen-btn"
                                    type="button"
                                    aria-label="Regenerate AI Prompt"
                                    onClick={handleRegen}>
                                    <i className="fas fa-sync-alt" alt="Regenerate icon" aria-hidden="true"></i>
                                    <span className="btn__tooltip btn__tooltip--small btn__tooltip--down ai-message-tooltip bg-white font-gray-40 border-solid border-1px border-color-gray-80">
                                        Regenerate Prompt
                                    </span>
                                </button>
                            }
                        </>
                    }
                </>
            )}
        </>
    );
};

AiActionButton.propTypes = {
    isLoading: PropTypes.bool,
    showButton: PropTypes.bool,
    isServiceError: PropTypes.bool,
};
export default AiActionButton;
